// Recarga la pagina UNA sola vez por sesion de navegador para recuperarse de un chunk de Vite
// obsoleto (ver main.tsx y ErrorBoundary.tsx). Sin esta guarda, si el problema real fuera otra
// cosa (ej. el deploy realmente esta roto), terminariamos en un loop de recargas infinito.
const FLAG_KEY = 'tutoraikids_chunk_reload_attempted';

export function reloadOnce(): void {
  try {
    if (sessionStorage.getItem(FLAG_KEY)) {
      // Ya intentamos recargar en esta sesion y el problema persiste -- no insistir mas,
      // dejar que se vea la pantalla de error para que la persona pueda reportarlo.
      return;
    }
    sessionStorage.setItem(FLAG_KEY, Date.now().toString());
  } catch {
    // sessionStorage puede fallar en navegacion privada/algunos navegadores -- si no podemos
    // recordar el intento, mejor no arriesgarnos a un loop y simplemente no recargar.
    return;
  }

  window.location.reload();
}

// Heuristica para detectar si un error atrapado por el ErrorBoundary es en realidad un chunk de
// Vite que no se pudo cargar (en vez de un bug real de la app), para poder intentar recargar en
// silencio en lugar de mostrar la pantalla de error tecnica.
export function isChunkLoadError(error: Error | null): boolean {
  if (!error) return false;
  const msg = error.message || '';
  return (
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg)
  );
}
